import { apiSlice } from '../api/apiSlice';

export const usersApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ["ToDo"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      GetUsers: builder.query({
        query: () => ({
          url: "/users",
        }),
        // providesTags: ["Users"],
      }),
      editUser: builder.mutation({
        query: (data) => ({
          url: "/client",
          method: "PUT",
          body: data,
        }),
        // invalidatesTags: ["Users"],
      }),
    }),
  });

export const { useEditUserMutation, useGetUsersQuery } = usersApiSlice;
